import { useState } from "react";
import { INITIAL_BIO } from "../../data/bio";
import { WINDOW_IDS, WINDOW_MENU } from "../../data/windows";
import { Window } from "../Window/Window";
import classes from "./Bio.module.css";

export const Bio = () => {
  const [bio, setBio] = useState(INITIAL_BIO);

  return (
    <Window id={WINDOW_IDS.BIO} classes={classes} menuItems={WINDOW_MENU}>
      <textarea
        onChange={(event) => setBio(event.target.value)}
        placeholder="Put it back >:c"
        id="myBio"
        value={bio}
      />
    </Window>
  );
};
